import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { Action } from './action';
import { DisputeTransactionModal, ManualPaymentRequestModal, RequestPhysicalDocumentationsModal, SwiftConfirmationModal } from './modals';
import { Text } from '@shared/widgets';

interface MessageTemplatesProps {
  className?: string;
}

export const MessageTemplates = (props: MessageTemplatesProps) => {
  const { tranId } = useParams<{ tranId: string }>();

  const [showManualPaymentRequestModal, setShowManualPaymentRequestModal] = useState<boolean>(false);
  const [showSwiftConfirmationModal, setShowSwiftConfirmationModal] = useState<boolean>(false);
  const [showDisputeTransactionModal, setShowDisputeTransactionModal] = useState<boolean>(false);
  const [showRequestPhysicalDocumentationsModal, setShowRequestPhysicalDocumentationsModal] = useState<boolean>(false);

  const { t } = useTranslation('messageCenter');

  const actions = useMemo(
    () =>
      [
        !tranId && { title: 'Manual Payment Request', clickHandler: () => setShowManualPaymentRequestModal(true) },
        { title: 'SWIFT Confirmation', clickHandler: () => setShowSwiftConfirmationModal(true) },
        { title: 'Dispute Transaction', clickHandler: () => setShowDisputeTransactionModal(true) },
        !tranId && { title: 'Request Physical Documentations', clickHandler: () => setShowRequestPhysicalDocumentationsModal(true) },
      ].filter(Boolean) as { title: string; clickHandler: () => void }[],
    [t],
  );
  return (
    <section
      className={cn(
        'flex w-full flex-col items-start justify-start gap-4 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl',
        props.className,
      )}
    >
      <Text weight='semibold' size='lg'>
        Quick Messages
      </Text>
      <div className={cn('flex w-full gap-2', PaletteUtils.isVcfcPalette && 'max-lg:flex-col')}>
        {actions.map((action, idx) => (
          <Action key={idx} title={action.title} onClick={action.clickHandler} />
        ))}
      </div>
      <ManualPaymentRequestModal isOpen={showManualPaymentRequestModal} onClose={() => setShowManualPaymentRequestModal(false)} />
      <SwiftConfirmationModal isOpen={showSwiftConfirmationModal} onClose={() => setShowSwiftConfirmationModal(false)} />
      <DisputeTransactionModal isOpen={showDisputeTransactionModal} onClose={() => setShowDisputeTransactionModal(false)} />
      <RequestPhysicalDocumentationsModal
        isOpen={showRequestPhysicalDocumentationsModal}
        onClose={() => setShowRequestPhysicalDocumentationsModal(false)}
      />
    </section>
  );
};
